import { Component, computed, effect, inject, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule, NgIf } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { ButtonModule } from 'primeng/button';
import { SanitizeHtmlTextPipe } from '../../../shared/pipes/sanitize-html-text.pipe';
import { HeaderComponent } from '../../auctions/header/header.component';
import { FooterComponent } from '../../auctions/footer/footer.component';
import { Router, RouterModule } from '@angular/router';
import { IItemDonationResponse } from '../../../models/IItemDonationResponse';
import { ThemeService } from '../../../services/theme.service';



@Component({
  selector: 'app-item-donation-thank-you-page',
  imports: [NgIf, CommonModule, ButtonModule, SanitizeHtmlTextPipe, HeaderComponent, FooterComponent, RouterModule],
  templateUrl: './item-donation-thank-you-page.component.html',
  styleUrl: './item-donation-thank-you-page.component.scss'
})
export class ItemDonationThankYouPageComponent implements OnInit {

  @Input() donationResponse: IItemDonationResponse | null = null;
  @Input() auctionId: number | null = null;

  item: IItemDonationResponse | null = null;
  formattedImages: string[] | null = [];
  selectedImage!: string;


  private readonly apiService = inject(ApiService);
  homePageSignal = this.apiService.homePageSignal;  
  protected readonly themeService = inject(ThemeService);
  


  itemDetailsSingalModal = computed(() => this.apiService.itemDetailSignal());
  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')

  constructor(private router: Router) {
    effect(() => {
      // const item = this.itemDetailsSingalModal();

      // console.log(item);

      // if (item) {
      //   this.item = item;

      //   if (item.imageUrl) {
      //     this.item.imageUrl = item.imageUrl && item.imageUrl.trim()
      //       ? (item.imageUrl.startsWith('http') ? item.imageUrl.trim() : `${environment.apiUrl}/${item.imageUrl.trim()}`)
      //       : '/ticket-default.jpg',
      //       this.selectedImage = this.item.imageUrl;

      //     if (item?.additionalImagesUrls.length > 0) {
      //       this.galery = item?.additionalImagesUrls;

      //       this.galery = this.galery.map(image =>
      //         image && image.trim()
      //           ? `${environment.apiUrl}/${image.trim()}`
      //           : '/item-default.jpg'
      //       );

      //       this.galery.unshift(this.item.imageUrl);
      //     }

      //   }
      // }
    });
  }

  ngOnInit(): void {


    if (typeof window !== 'undefined' && window.history.state) {     
  
      const state = window.history.state as {
        newItem: IItemDonationResponse;
        auctionId: number;
      };       

      // console.log(state?.newItem)

      if (state?.newItem && state?.auctionId) {
        this.item = state.newItem;
        this.auctionId = state.auctionId;
      }

      //  this.themeService.setPreset('bfg'); 
      this.themeService.customizeAuctionTheme(this.auctionId ?? 0);


      if (!this.apiService.homePageSignal()) {
        const endpoint = 'auctions';
        this.apiService.getAuctionHomePageData(endpoint, this.auctionId!);
        localStorage.setItem('homePageData', JSON.stringify(this.apiService.homePageSignal()));
      }


    }

    // console.log('before item images', this.item);

    if (this.item) {


      this.formattedImages = this.item.images.map(imageUrl =>
        imageUrl && imageUrl.trim()
          ? (imageUrl.startsWith('http')
            ? imageUrl.trim()
            : `${environment.apiUrl}/${imageUrl.trim()}`)
          : '/ticket-default.jpg'
      );

      this.selectedImage = this.formattedImages[0] ?? '/ticket-default.jpg';
    }
  }

}
